/**
 * Frontend JavaScript Entry Point
 *
 * This file is bundled with esbuild and loaded on the frontend.
 * Import Stimulus controllers and other frontend functionality here.
 */

// Import Stimulus controllers
import "./controllers";

// Example: Initialize custom functionality
document.addEventListener("DOMContentLoaded", () => {
  console.log("Natuerlich Reisen Plugin loaded");

  // Add any global frontend initialization here
});
